// src/pages/GraficoPerfilICV.jsx
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList } from 'recharts';

const ORDEM_FATORES = [
  'DGV', 'R', 'A', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'
];

export default function GraficoPerfilICV({ ptResultados }) {
  if (!ptResultados) return null;

  // Constrói dados para o gráfico, na ordem correta dos fatores
  const data = ORDEM_FATORES.map(fator => ({
    fator,
    PT: ptResultados[fator] ?? 0,
  }));

  return (
    <div style={{ width: '100%', height: 300, margin: '2rem 0' }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}
          margin={{ top: 30, right: 32, left: 12, bottom: 8 }}>
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <XAxis dataKey="fator" />
          <YAxis domain={[0, 'dataMax+2']} allowDecimals={false} />
          <Tooltip formatter={(v) => `PT = ${v}`} />
          <Line
            type="monotone"
            dataKey="PT"
            stroke="#2A398B"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 7 }}
            isAnimationActive={false}
          >
            <LabelList dataKey="PT" position="top" fontSize={13} />
          </Line>
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
